import MenuMobile from './common/menuMobile';
import HeaderCart from './common/headerCart';
import Footer from './common/footerTabs';
import Popup from './components/popup';
import FixedHeader from './common/fixedHeader';
import Webforms from './common/webforms';
import Search from './common/search';

import { getPriceProd } from './components/utilities';
import { setNewsletterPopup } from './components/vndaComponents';

const page = document.querySelector('body').getAttribute('data-page');

// ==========================================
// Inicialização
// ==========================================
console.log(
  '%cOlist - Soluções de vendas online e Serviços de E-commerce',
  'color: #0a4ee4; font-size: 14px; font-family: "Verdana", sans-serif; font-weight: bold;'
);

window.addEventListener('DOMContentLoaded', () => {

  MenuMobile.init();
  HeaderCart.init();
  getPriceProd();
  FixedHeader.init();
  Footer.init();
  Popup.init();
  Webforms.init();
  Search.init();
  setNewsletterPopup();

  if (page == 'home') {
    import('./pages/home')
      .then(({ default: Home }) => { Home.init() })
      .catch(error => { console.error(error) })
  }
  
  // if (page == 'product') {
  //   import('./pages/product')
  //     .then(({ default: Product }) => { Product.init() })
  //     .catch(error => { console.error(error) })
  // }

  if (page == 'tag') {
    import('./pages/tag')
      .then(({ default: Tag }) => { Tag.init() })
      .catch(error => { console.error(error) })
  }
  
  if (page == 'login') {
    import('./pages/loginPage')
      .then(({ default: LoginPage }) => { LoginPage.init() })
      .catch(error => { console.error(error) })
  }

  if (page == 'page') {
    import('./pages/page')
      .then(({ default: Page }) => { Page.init() })
      .catch(error => { console.error(error) })
  }
  
});
